module.exports = __webpack_public_path__ + "static/img/main_electric_top_line.fe568de3.png";